import { createFileRoute } from "@tanstack/react-router";
import { MfeMount } from "../presentational/MfeMount";

export const Route = createFileRoute("/$")({
  component: MfeMount,
});
